import { storeToRefs } from 'pinia';
import { useCompanyStore } from '@/stores/company';
import { useLocalizationStore } from '@/stores/localization';

export const Airtable = () => {
  const { company } = storeToRefs(useCompanyStore());
  const { language } = storeToRefs(useLocalizationStore());

  const customizeWebsiteFormIds = {
    de: 'shrTj1uL7wHoFaZEo',
    nl: 'shr6fHXnggZwC72mg',
    en: 'shr9gRzgqNo1Do9HH',
    fr: 'shrx4G3hZb11DEppt',
  };
  const changeRequestFormIds = {
    de: 'shrbOgWpj7N6ve6xX',
    nl: 'shrcXrKwGlZ6vi187',
    en: 'shrRlwX0cFJVVhyXw',
    fr: 'shr9o5HaBbCqNwaWu',
  };

  const baseUrl = 'https://airtable.com/appVNoxXkWFOPsDFl/';

  const params = new URLSearchParams({
    prefill_Name: company.value.name,
    prefill_CompanyID: company.value.id.toString(),
    hide_CompanyID: 'true',
  });

  const customizeWebsiteFormId =
    customizeWebsiteFormIds[
      language.value as keyof typeof customizeWebsiteFormIds
    ] ?? customizeWebsiteFormIds.en;
  const changeRequestFormId =
    changeRequestFormIds[language.value as keyof typeof changeRequestFormIds] ??
    changeRequestFormIds.en;

  const customizeWebsiteUrl = `${baseUrl}${customizeWebsiteFormId}?${params.toString()}`;
  const changeRequestUrl = `${baseUrl}${changeRequestFormId}?${params.toString()}`;

  return {
    customizeWebsiteUrl,
    changeRequestUrl,
  };
};
